import { TotalsChip } from '@/domains/home/components/home-tabs/_components/base-chip';
import { TooltipButton } from '@/comps/tooltip-button';
import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';
import { cn } from '@/utils/shad';

type TableHeadContentProps = {
  title: string;
  total: number;
  showTotal?: boolean;
  tooltipText?: string;
  truncate?: boolean;
};

export function TableHeadContent({
  title,
  total,
  tooltipText,
  showTotal = true,
  truncate = false,
}: TableHeadContentProps) {
  return (
    <div className={cn('flex items-center gap-1 text-[12px]!', truncate && 'min-w-0 overflow-hidden')}>
      <p className={cn(truncate && 'overflow-hidden text-ellipsis whitespace-nowrap')}>{title}</p>
      {showTotal && <TotalsChip total={total} />}
      {tooltipText && (
        <TooltipButton content={tooltipText}>
          <QuestionMarkCircledIcon className="ml-1 inline h-base w-base text-muted-foreground hover:cursor-pointer" />
        </TooltipButton>
      )}
    </div>
  );
}
